import { render, staticRenderFns } from "./image-gallery.vue?vue&type=template&id=4870db40&scoped=true"
import script from "./image-gallery.vue?vue&type=script&lang=js"
export * from "./image-gallery.vue?vue&type=script&lang=js"
import style0 from "./image-gallery.vue?vue&type=style&index=0&id=4870db40&prod&lang=css"
import style1 from "./image-gallery.vue?vue&type=style&index=1&id=4870db40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870db40",
  null
  
)

export default component.exports